import ar from './ar-AE'
import arKW from './ar-KW'
import arQA from './ar-QA'
import arSA from './ar-SA'
import bg from './bg-BG'
import cs from './cs-CZ'
import da from './da-DK'
import deAT from './de-AT'
import deCH from './de-CH'
import de from './de-DE'
import el from './el-GR'
import enAE from './en-AE'
import enAU from './en-AU'
import enBH from './en-BH'
import enCA from './en-CA'
import enCH from './en-CH'
import enEG from './en-EG'
import enGB from './en-GB'
import enHK from './en-HK'
import enHR from './en-HR'
import enIE from './en-IE'
import enIL from './en-IL'
import enIN from './en-IN'
import enJO from './en-JO'
import enKE from './en-KE'
import enKW from './en-KW'
import enMO from './en-MO'
import enMU from './en-MU'
import enMY from './en-MY'
import enNG from './en-NG'
import enNZ from './en-NZ'
import enPH from './en-PH'
import enPK from './en-PK'
import enQA from './en-QA'
import enRS from './en-RS'
import enSA from './en-SA'
import enSG from './en-SG'
import enTH from './en-TH'
import enTZ from './en-TZ'
import en from './en-US'
import enVN from './en-VN'
import enZA from './en-ZA'
import esAR from './es-AR'
import esCL from './es-CL'
import esCO from './es-CO'
import esCR from './es-CR'
import esDO from './es-DO'
import esEC from './es-EC'
import esES from './es-ES'
import esGT from './es-GT'
import esHN from './es-HN'
import es from './es-LA'
import esMX from './es-MX'
import esNI from './es-NI'
import esPA from './es-PA'
import esPE from './es-PE'
import esPY from './es-PY'
import esSV from './es-SV'
import esUY from './es-UY'
import et from './et-EE.json'
import fi from './fi-FI'
import frBE from './fr-BE'
import frCA from './fr-CA'
import frCH from './fr-CH'
import fr from './fr-FR'
import he from './he-IL'
import hiIN from './hi-IN'
import hr from './hr-HR'
import hu from './hu-HU'
import itCH from './it-CH'
import it from './it-IT'
import lt from './lt-LT.json'
import lv from './lv-LV.json'
import ms from './ms-MY'
import nb from './nb-NO'
import nlBE from './nl-BE'
import nl from './nl-NL'
import pl from './pl-PL'
import pt from './pt-BR'
import ptMO from './pt-MO'
import ptPT from './pt-PT'
import ro from './ro-RO'
import ru from './ru-RU'
import sk from './sk-SK'
import srRS from './sr-RS'
import svFi from './sv-FI'
import sv from './sv-SE'
import th from './th-TH'
import tr from './tr-TR'
import uk from './uk-UA'
import vi from './vi-VN'
import zh from './zh-HK'
import zhMO from './zh-MO'
import zhSG from './zh-SG'

export default {
  ar,
  'ar-KW': arKW,
  'ar-QA': arQA,
  'ar-SA': arSA,
  bg,
  cs,
  da,
  de,
  'de-AT': deAT,
  'de-CH': deCH,
  el,
  en,
  'en-AE': enAE,
  'en-AU': enAU,
  'en-BH': enBH,
  'en-CA': enCA,
  'en-CH': enCH,
  'en-EG': enEG,
  'en-GB': enGB,
  'en-HK': enHK,
  'en-HR': enHR,
  'en-IE': enIE,
  'en-IL': enIL,
  'en-IN': enIN,
  'en-JO': enJO,
  'en-KE': enKE,
  'en-KW': enKW,
  'en-MO': enMO,
  'en-MU': enMU,
  'en-MY': enMY,
  'en-NG': enNG,
  'en-NZ': enNZ,
  'en-PH': enPH,
  'en-PK': enPK,
  'en-QA': enQA,
  'en-RS': enRS,
  'en-SA': enSA,
  'en-SG': enSG,
  'en-TH': enTH,
  'en-TZ': enTZ,
  'en-VN': enVN,
  'en-ZA': enZA,
  es,
  'es-AR': esAR,
  'es-CL': esCL,
  'es-CO': esCO,
  'es-CR': esCR,
  'es-DO': esDO,
  'es-EC': esEC,
  'es-ES': esES,
  'es-GT': esGT,
  'es-HN': esHN,
  'es-MX': esMX,
  'es-NI': esNI,
  'es-PA': esPA,
  'es-PE': esPE,
  'es-PY': esPY,
  'es-SV': esSV,
  'es-UY': esUY,
  et,
  fi,
  fr,
  'fr-BE': frBE,
  'fr-CA': frCA,
  'fr-CH': frCH,
  he,
  'hi-IN': hiIN,
  hr,
  hu,
  it,
  'it-CH': itCH,
  lt,
  lv,
  ms,
  nb,
  nl,
  'nl-BE': nlBE,
  pl,
  pt,
  'pt-MO': ptMO,
  'pt-PT': ptPT,
  ro,
  ru,
  sk,
  'sr-RS': srRS,
  sv,
  'sv-FI': svFi,
  th,
  tr,
  uk,
  vi,
  zh,
  'zh-MO': zhMO,
  'zh-SG': zhSG
}
